import googleMapLocation from '../../../assets/images/Home/ContactUs/googleMapLocation.png'
import ContactUsForm from './ContactUsForm'

const ContactUs = () => {
  return (
    <div
        className="flex flex-col items-center lg:items-start p-6 justify-center w-full bg-black mt-8"
        style={{
            backgroundImage: `url(${googleMapLocation})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            height: '100%',
            width: '100%',
            position: 'relative',
            zIndex: '0',
            borderRadius: '10px',
        }}
    >
        {/* contact us form */}
        <form className="bg-white rounded-lg shadow-lg z-10 w-10/12 lg:w-7/12">
            <ContactUsForm />
        </form>

    </div>
  )
}

export default ContactUs